<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--top">
            <header class="l-header l-header--top">
                <public-page-header/>
            </header>

            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <header class="article-header">
                                                            <h1>導入・ご利用方法</h1>
                                                            <div class="eyecatch-img">
                                                                <span></span>
                                                            </div>
                                                        </header>
                                                        <div class="company-page">
                                                            <section class="article-content">
                                                                <div id="btn-contact-wrap"
                                                                    class="btn-wrap company-contact-cta">
                                                                    <p class="txt">ご不明な点がございましたら、お問い合わせください</p>
                                                                    <p class="btn"><a href="/contactus">お問合せ</a></p>
                                                                </div>
                                                            </section>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>

</template>
<script setup>
import { onMounted } from "vue";
import { initializeTop } from "@/assets/js/entries/top.js";
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});

onMounted(() => {
    initializeTop();
})
</script>